import request from '@/utils/request'

//获取默认收货地址
export function getDefaultUserAddressReq(query) {
  return request({
    url: '/api/userAddress/getDefaultUserAddress',
    method: 'GET',
    params: query , //params修改为data
  })
}

// 添加地址
export function addUserAddressReq(query) {
  return request({
    url: '/api/userAddress/addUserAddress',
    method: 'GET',
    params: query , //params修改为data
  })
}
//修改地址
export function updateUserAddressReq(query) {
  return request({
    url: '/api/userAddress/updateUserAddress',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取地址详情
export function getUserAddressReq(query) {
  return request({
    url: '/api/userAddress/getUserAddress',
    method: 'GET',
    params: query , //params修改为data
  })
}

//查询地址列表
export function getUserAddressListReq(query) {
  return request({
    url: '/api/userAddress/getUserAddressList',
    method: 'GET',
    params: query , //params修改为data
  })
}

//获取物流地址
export function getDeliveryListReq(query) {
  return request({
    url: '/api/order/getDeliveryList',
    method: 'GET',
    params: query , //params修改为data
  })
}

//删除地址
export function delUserAddressReq(query) {
  return request({
    url: '/api/userAddress/delUserAddress',
    method: 'GET',
    params: query , //params修改为data
  })
}

//模糊识别
export function recognitionReq(query) {
  return request({
    url: '/api/userAddress/recognition',
    method: 'GET',
    params: query , //params修改为data
  })
}

